<div class="custom-meal-menu-popup" wrapFocus >
  <h4>Choose your meal</h4>
  <ul role="listbox" class="dropdown-menu">
    <li role="option" attr.aria-label ="{{mealoption?.name}}" (keydown.enter)="chooseMealOption(mealoption)"  [attr.aria-selected]="isCurrentMealOptionSelected(mealoption)" tabindex=0 *ngFor="let mealoption of activeMenuMealOptions.recipes; let i=index" (click)="chooseMealOption(mealoption)">
      <div class="media" [ngClass]="{'active': isCurrentMealOptionSelected(mealoption)}">
        <span class="pull-left">
          <img src="{{menuImageUrlPrefix}}/{{mealoption.imageUrl}}" class="media-object" alt="{{mealoption.name}}">
        </span>
        <div class="media-body">
          <!-- <h5 class="media-heading">{{mealoption.displayName}}</h5> -->
          <h5 class="media-heading">{{getMealOptionName(activeMenuMealOptions.name, mealoption.name)}}</h5>
          <p>{{mealoption.comesWithTextWeb ?? mealoption.comesWithText ?? ''}}</p>
        </div>
      </div>
    </li>
  </ul>
  <div>
    <button class="btn wb-btn-outline mg-top-24 cancel-btn text-center" (click)="hide()">Cancel</button>
  </div>
</div>